export const calculators = [
  {
    id: 'company-calculator',
    titleKey: 'calculators.company.title',
    descriptionKey: 'calculators.company.description',
    icon: '/images/building.png',
  },
  {
    id: 'personal-calculator',
    titleKey: 'calculators.personal.title',
    descriptionKey: 'calculators.personal.description',
    icon: '/images/user.png',
  },
  {
    id: 'trips-calculator',
    titleKey: 'calculators.trips.title',
    descriptionKey: 'calculators.trips.description',
    icon: '/images/myTrip.png',
  },
  {
    id: 'car-calculator',
    titleKey: 'calculators.car.title',
    descriptionKey: 'calculators.car.description',
    icon: '/images/car.png',
  },
];
